
export const getConfigHLS = (options) => {
  const src = options.src;
  const poster = options.backgroundImage;
  const config = {
    title: '',
    description: '',
    poster,
    hls: src
  };
  return config;

}



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/streams-types-config/HLS.js